import styled from '@emotion/styled';

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;

export const SStatusCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SFiltersContainer = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: row;
    gap: 0 16px;
`;
